import {  Box, styled } from "@mui/system";
import CommonLabel from "./label";
import { Typography } from "@mui/material";
import ArrowOutwardIcon from "@mui/icons-material/ArrowOutward";
import { createApiCall } from "../api/api-service";
const GradientText = styled(Typography)(({ theme }) => ({
  background: `linear-gradient(60deg,${theme.palette.primary.main},${theme.palette.secondary.main})`,
  WebkitBackgroundClip: "text",
  WebkitTextFillColor: "transparent",
  fontWeight: "bold",
}));
const RetailorPrice = ({key,retailerData,otherinfo}) => {

  const track_user_click = async (retData) =>{
   await  createApiCall("POST","/tracking/track-user-clicked-ecom",retData)
  }

  return (
    <Box key={key}
      sx={{
        width: "100%",
        height: "50px",
        border: "2px solid #ecedee",
        borderRadius: "999px",
        display: "flex",
        justifyContent: "space-between",
        alignItems:'center'
      }}
    >
      <Box sx={{display:'flex',gap:'5px',flexDirection:'row',marginLeft:'15px',alignItems:'center'}}>
        {/* <img
          width={"45px"}
          height={"45px"}
          src={retailerData?.logo}
        /> */}

        <CommonLabel> {retailerData?.ecommerce_name} </CommonLabel>
       { key === 0 ? <CommonLabel sx={{color:'green'}}>{otherinfo}</CommonLabel> : ''}
      </Box>
      <Box sx={{marginRight:'15px'}}>
        <a href={retailerData?.affiliate_url} target="_blank" rel="noopener noreferrer affliated" style={{ textDecoration: "none", display: "inline-flex", alignItems: "center", gap: "5px" }} onClick={() => {track_user_click(retailerData)}}>
        <GradientText>
          <span> ₹ {retailerData?.ecommerce_price}   </span>
          
            <ArrowOutwardIcon sx={{ color: "#F857A6" }} fontSize="1rem" />
        </GradientText>
          </a>
      </Box>
    </Box>
  );
};

export default RetailorPrice;
